// const DEFAULT = 'DEFAULT';
export const LINES_TO_SHOW = 1;
export const DEFAULT_COLOR = { primary: '#1D428A', secondary: '#E1072A' };
export const MAX_EVENTS = 4;
// export const HotelNameList = [
//     {
//         value: 1,
//         label: 'Archer Hotel New York',
//     },
//     {
//         value: 2,
//         label: 'JW Marriott Hotel Miami',
//     },
// ];

export const HotelNeeded = [
    {
        value: 1,
        label: 'Yes',
    },
    {
        value: 0,
        label: 'No',
    },
];

export const RoomAndTax = [
    {
        value: 1,
        label: 'Complimentary',
    },
    {
        value: 2,
        label: 'Purchase',
    },
];

// export const RoomType = [
//     {
//         value: 1,
//         label: 'Single Room',
//     },
//     {
//         value: 2,
//         label: 'Double Room',
//     },
// ];
export const RoomType = [
    {
        value: 1,
        label: '1 Bed',
    },
    {
        value: 2,
        label: '2 Bed',
    },
];
export const excelFileType = [
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];

export const participantStatus = [
    { id: 0, name: '#C8102E' },
    { id: 1, name: '#BC8D15' },
    { id: 2, name: '#148845' },
    { id: 3, name: '#C8102E' },
];
export const getStatus = (statusID) => {
    const status = participantStatus.find((item) => item.id === statusID)?.name;
    if (status) {
        return status;
    } else {
        return '#C8102E';
    }
};

export const MODULE_LIST = [
    'TRANSPORTATION',
    'REGISTRATION',
    'DRAFTREGISTRATION',
    'INVITATION',
    'HOTEL',
    'OUTFIT',
    'TICKET',
    'DRAFTHOTEL',
    'ALLSTARREGISTRATION',
    'ALLSTARHOTEL',
    'DRAFTTRANSPORTATION',
    'COMBINETRANSPORTATION',
    'CREDENTIAL',
    'GREENROOM',
    'LUNCHROOM',
    'DRAFTFLIGHTINFO'
];
export const FULL_PERMISSION = 'FULL';
export const VIEW_PERMISSION = 'VIEW';
export const NO_ACCESS_PERMISSION = 'NO_ACCESS';

export const HOTEL_ROOM_TAX = ['Complimentary', 'For Purchase', 'Waitlist Request'];
export const REQUEST_STATUS_LIST = ['Approved', 'Pending', 'Not Approved'];

export const eventView = [
    { value: 0, name: 'Publish' },
    { value: 1, name: 'Read Only' },
    { value: 2, name: 'Hide' },
];

export const eventRoles = 'Event Admin';

export const userType = 'Admin';

export const ScheduleUserType = ['Participant', 'Event Staff'];

export const ScheduleUserAdminType = [
    'Participant',
    'Event Staff',
    'Event Admin',
];

export const RequestStatus = {
    TO_DO: 'To Do',
    PENDING: 'Pending',
    APPROVED: 'Approved',
    REJECTED: 'Rejected',
    CANCELLED: 'Cancelled'
};
